import { INonStandardEquipment } from "Model/INonStandardEquipment";
import { isEmail } from "utils";
const ValidateMake = (orderDetails: any, error: any) => {
    if (orderDetails.make === undefined || orderDetails.make === "" || orderDetails.make === null) {
        error.makeError = "Please enter make";
    } else if (orderDetails.make.length > 50) {
        error.makeError = "Please enter Make less than 50 Characters";
    } else {
        error.makeError = "";
    }
    return error;
}
const ValidateModel = (orderDetails: any, error: any) => {
    if (orderDetails.model === undefined || orderDetails.model === '' || orderDetails.model === null) {
        error.modelError = "Please enter model no.";
    } else if (orderDetails.model.length > 50) {
        error.modelError = "Please enter Model less than 50 Characters";
    } else {
        error.modelError = "";
    }
    return error;
}
const ValidateYear = (orderDetails: any, error: any) => {
    if (orderDetails.year?.value === undefined || orderDetails.year?.value === 0 || orderDetails.year?.value === null) {
        error.yearError = "Please select year";
    } else {
        error.yearError = "";
    }
    return error;
}
const ValidateIsUsed = (orderDetails: any, error: any) => {
    if (orderDetails.isUsed === undefined || orderDetails.isUsed === "" || orderDetails.isUsed === null) {
        error.isUsedError = "Please select used";
    } else {
        error.isUsedError = "";
    }
    return error;
}
const ValidatePricePerUnit = (orderDetails: any, error: any) => {
    if (orderDetails.pricePerUnit === undefined || orderDetails.pricePerUnit === 0 || orderDetails.pricePerUnit === null) {
        error.pricePerUnitError = "Please enter unit price";
    } else if (orderDetails.pricePerUnit.toString().length > 15) {
        error.pricePerUnitError = "Please enter Unit Price less than 15 Digits";
    } else {
        error.pricePerUnitError = "";
    }
    return error;
}
const ValidateQuantity = (orderDetails: INonStandardEquipment, error: any) => {
    if (orderDetails.quantity === undefined || orderDetails.quantity === 0 || orderDetails.quantity === null) {
        error.quantityError = "Please enter valid quantity";
    } else {
        error.quantityError = "";
    }
    return error;
}
const ValidateVendorName = (orderDetails: INonStandardEquipment, error: any) => {
    if (orderDetails.vendorName === undefined || orderDetails.vendorName === "" || orderDetails.vendorName === null) {
        error.vendorNameError = "Please select vendor name";
    } else {
        error.vendorNameError = "";
    }
    return error;
}

const ValidateDealerContact = (orderDetails: INonStandardEquipment, error: any) => {
    if (orderDetails.dealerContact === undefined || orderDetails.dealerContact === '' || orderDetails.dealerContact === null) {
        error.dealerContactError = "Please enter dealer contact";
    } else if (orderDetails.dealerContact.length > 100) {
        error.dealerContactError = "Please enter Dealer Contact less than 100 characters";
    } else {
        error.dealerContactError = "";
    }
    return error;
}
const ValidateDealerPhone = (orderDetails: any, error: any) => {
    if (orderDetails?.dealerPhone == 0 || orderDetails?.dealerPhone == "" || orderDetails?.dealerPhone == undefined || orderDetails?.dealerPhone?.match(/\d/g) === null || orderDetails?.dealerPhone?.match(/\d/g).length < 10) {
        error.dealerPhoneError = "Please enter valid dealer phone";
    } else {
        error.dealerPhoneError = "";
    }
    return error;
}
const ValidateEmailAddress = (orderDetails: INonStandardEquipment, error: any) => {
    

    if (orderDetails.emailAddress === undefined || orderDetails.emailAddress === "" || orderDetails.emailAddress === null || isEmail( orderDetails.emailAddress )) {
        error.emailAddressError = "Please enter valid email address";
    } else if (orderDetails.emailAddress.length > 50) {
        error.emailAddressError = "Please enter Email Address less than 50 characters";
    } else {
        error.emailAddressError = "";
    }
    return error;
}
const ValidateAddress1 = (orderDetails: INonStandardEquipment, error: any) => {
    if (orderDetails.address1 === undefined || orderDetails.address1 === "" || orderDetails.address1 === null) {
        error.address1Error = "Please enter address 1";
    } else if (orderDetails.address1.length > 200) {
        error.address1Error = "Please enter Address 1 less than 200 characters";
    } else {
        error.address1Error = "";
    }
    return error;
}
const ValidateAddress2 = (orderDetails: INonStandardEquipment, error: any) => {
    if (orderDetails.address2.length > 200) {
        error.address2Error = "Please enter Address 2 less than 200 characters";
    } else {
        error.address2Error = "";
    }
    return error;
}
const ValidateAddress3 = (orderDetails: INonStandardEquipment, error: any) => {
    if (orderDetails.address3.length > 200) {
        error.address3Error = "Please enter Address 3 less than 200 characters";
    } else {
        error.address2Error = "";
    }
    return error;
}
const ValidateCity = (orderDetails: INonStandardEquipment, error: any) => {
    if (orderDetails.city === undefined || orderDetails.city === "" || orderDetails.city === null) {
        error.cityError = "Please enter city";
    } else if (orderDetails.city.length > 100) {
        error.cityError = "Please enter City less than 100 characters.";
    } else {
        error.cityError = "";
    }
    return error;
}
const ValidateState = (orderDetails: INonStandardEquipment, error: any) => {
    if (orderDetails.state === undefined || orderDetails.state === "" || orderDetails.state === null) {
        error.stateError = "Please enter state";
    } else if (orderDetails.state.length > 2) {
        error.stateError = "Please enter State less than 2 characters.";
    } else {
        error.stateError = "";
    }
    return error;
}
const ValidateZip = (orderDetails: INonStandardEquipment, error: any) => {
    if (orderDetails.zip === undefined || orderDetails.zip === 0 || orderDetails.zip === null || orderDetails.zip.toString() === "") {
        error.zipError = "Please enter zip";
    } else if (orderDetails.zip > 9999999999) {
        error.zipError = "Please enter Zip less than 10 digits.";
    } else {
        error.zipError = "";
    }
    return error;
}

const ValidateVinSerial = (orderDetails: INonStandardEquipment, error: any) => {
    if (orderDetails.vinSerial.length > 30) {
        error.vinSerialError = "Please enter VIN/Series less than 30 Characters";
    } else {
        error.vinSerialError = "";
    }
    return error;
}

const ValidateDescription = (orderDetails: INonStandardEquipment, error: any) => {
    if (orderDetails?.description?.length > 200) {
        error.descriptionError = "Please enter Description less than 200 Characters";
    } else {
        error.descriptionError = "";
    }
    return error;
}


export default {
    ValidateMake,
    ValidateModel,
    ValidateYear,
    ValidateIsUsed,
    ValidatePricePerUnit,
    ValidateVendorName,
    ValidateDealerContact,
    ValidateDealerPhone,
    ValidateEmailAddress,
    ValidateAddress1,
    ValidateCity,
    ValidateState,
    ValidateZip,
    ValidateVinSerial,
    ValidateDescription,
    ValidateAddress2,
    ValidateAddress3
}